/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default {

  resetRateTypes() {
    // reset store to empty
    Store.dispatch('routes/setRateTypes', {
      rateTypes: [],
    });
  },

  async listRateTypes(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['routes/rateTypes'].length < 1) {
      try {
        const response = await Api(true).get('/route/list_rate_types');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetRateTypes();
            return response.data.message;
          } else {
            Store.dispatch('routes/setRateTypes', {
              rateTypes: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetRateTypes();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('routes.ts - listRateTypes - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetStore() {
    // reset store to empty
    Store.dispatch('routes/setRoutes', {
      routes: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['routes/routes'].length < 1) {
      try {
        const response = await Api(true).get('/route/list_all');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('routes/setRoutes', {
              routes: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('route.ts - listAll - 89 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    customerId: number,
    typeId: number,
    from: string,
    to: string,
    rate: number,
    routeKm?: number,    
  }) {
    return Api(true).post('/route/create', params);
  },

  update(params: {
    id: number,
    typeId: number,
    from: string,
    to: string,
    rate: number,
    routeKm?: number,
  }) {
    return Api(true).post('/route/update', params);
  },

  delete(params: {
    id: number,
  }) {
    return Api(true).post('/route/delete', params);
  },

  zeroAllRates(params: {
    id: number,
  }) {
    return Api(true).post('/route/zero_all', params);
  },

  copy(params: {
    fromCustomerId: number,
    toCustomerId: number,
  }) {
    return Api(true).post('/route/copy', params);
  },

};
